import { withFormik } from 'formik';
import { connect } from 'react-redux';
import { addReport } from '../../../../slices/postSlice';
import ReportPostForm from './ReportPostForm';
import * as Yup from 'yup';

//constants

const EnhancedRepostPostForm = withFormik({
  mapPropsToValues: () => ({
    text: '',
  }),
  validationSchema: Yup.object().shape({
    text: Yup.string().required('Report text is required!'),
  }),
  handleSubmit: (values, { setSubmitting, resetForm, props }) => {
    const {
      addReport,
      setOpenModal,
      post: { post },
    } = props;
    if (values.text === '') {
    } else {
      addReport(values, post.post._id);
    }
    setOpenModal(false);
    setSubmitting(false);
    resetForm({ text: '' });
  },
  displayName: 'ReportPostForm',
})(ReportPostForm);

const mapStateToProps = (state) => ({
  post: state.post,
});

export default connect(mapStateToProps, { addReport })(EnhancedRepostPostForm);
